import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import SearchTextField from "@/components/Search/SearchTextField";
import { setSearchTerm } from "@/store/authSlice";

const UserSearchTextField = () => {
    const dispatch = useDispatch();
    const searchTerm = useSelector((s) => s.auth.searchTerm || "");

    useEffect(() => {
        return () => {
            dispatch(setSearchTerm(""));
        };
    }, [dispatch]);

    return (
        <SearchTextField
            value={searchTerm}
            onChange={(e) => dispatch(setSearchTerm(e.target.value))}
            label="Search"
            placeholder="Enter Name or Email"
        />
    );
};

export default UserSearchTextField;
